import './PortProductLinePage.css'
import 'antd/dist/reset.css'
import React from 'react'
import PortBottomLayout from '../../common/PortBottomLayout'

export default class PortProductLinePage extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
  }

  componentDidMount() {
    window.scrollTo(0, 0)
  }

  render() {
    return (
      <div>
        <div className="PortProductLine">
          <div className="PortProductLineTitle">
            阀门设计与定制化柔性生产解决方案
            <br />
            ——精工智造，定义未来
          </div>
          <div className="PortProductLineText">
            作为高端仪表管阀领域的创新引领者，江苏凯士达阀门科技有限公司凭借自主研发的设计能力与柔性化智能生产体系，为全球客户提供高效、稳定、可靠的阀门产品与全流程解决方案。通过融合先进设备、创新工艺与数字化技术，我们助力客户在复杂工况中实现精准需求匹配，抢占市场先机。
          </div>
          <div className="PortProductLineSubtitle">
            核心优势：技术驱动，智造赋能
          </div>
          <div className="PortProductLineSmallTitle">顶尖阀门设计能力</div>
          <div className="PortProductLineText">
            专业研发团队：由资深工程师与行业专家领衔，深耕阀门流体力学、材料科学与密封技术，针对极端压力、腐蚀性介质等场景提供创新设计。
          </div>
          <div className="PortProductLineText">
            仿真优化技术：依托CFD流体仿真、FEA结构分析等数字化工具，精准优化产品性能，确保设计方案的高精度与高可靠性。
          </div>
          <div className="PortProductLineText">
            定制化开发：从尺寸适配到功能拓展，从标准产品到特殊工况需求，凯士达的设计能力覆盖全场景，为客户量身打造“专属阀门”。
          </div>
          <div className="PortProductLineSmallTitle">柔性化智能生产线</div>
          <div className="PortProductLineText">
            高端设备集群：配备全自动数控加工中心、高精度激光切割机等先进设备，支持多规格、多材质、小批量订单的高效切换。
          </div>
          <div className="PortProductLineText">
            工艺创新：自主开发超精密加工工艺与表面处理技术，显著提升阀门密封性、耐腐蚀性与使用寿命，满足半导体、氢能等行业的严苛标准。
          </div>
          <div className="PortProductLineText">
            敏捷交付：通过柔性排产与智能调度系统，实现订单快速响应，交付周期缩短30%，助力客户应对市场变化。
          </div>
          <div className="PortProductLineSmallTitle">数字化与智能化赋能</div>
          <div className="PortProductLineText">
            智能工厂体系：基于工业互联网平台，实现生产全流程数据互联，实时监控设备状态与工艺参数，确保品质零缺陷。
          </div>
          <div className="PortProductLineText">
            AI驱动优化：应用人工智能算法分析生产数据，动态优化加工路径与能耗管理，提升效率15%以上。
          </div>
          <div className="PortProductLineText">
            数字供应链：从需求对接、设计确认到物流追踪，全链路数字化服务保障透明高效，支持“一站式交付”。
          </div>
          <div className="PortProductLineText">
            全场景覆盖：无论是槽罐车高压阀门、半导体超高纯气体阀门，还是氢能储运特种阀门，我们均能提供技术领先的定制化方案。
          </div>
          <div className="PortProductLineText">
            品质承诺：通过ISO 9001等多项国际认证，产品性能对标全球顶尖标准。
          </div>
          <div className="PortProductLineText">
            价值升级：以柔性生产与智能技术为核心，帮助客户降低综合成本，提升市场竞争力。
          </div>
          <div className="PortProductLineSubtitle">
            未来愿景：智造无界，创新不止
          </div>
          <div className="PortProductLineText">
            凯士达将持续加码人工智能、5G+工业互联网等新一代技术研发，深化智能制造与数字供应链布局，推动阀门行业向“小批量、多样化、快交付”的定制时代迈进。
          </div>
        </div>

        <PortBottomLayout {...this.props} />
      </div>
    )
  }
}
